module.exports = __webpack_public_path__ + "img/em1.7c08957a.jpg";